//test
export const getCount = state => {
    return state.count
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js